import clsx from 'clsx';
import { IconButton } from './Button/IconButton';
import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface DrawerProps {
  header: React.ReactNode | string;
  children: React.ReactNode;
  className?: string;
  /**
   * Extra classes for the collapsing body. That body hides its overflow so the
   * open/close height animation does not spill, which also clips anything a
   * child pulls outside it with a negative margin. Pass a matching negative
   * margin and padding pair here to widen the clip box without moving content.
   */
  bodyClassName?: string;
}

export const Drawer = ({ header, children, className, bodyClassName }: DrawerProps) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className={clsx('flex flex-col w-full', className)}>
      <div className="grid grid-cols-[1fr,40px] items-center w-full min-h-[40px]">
        <div className="items-center text-darkMode-gray-medium font-bold text-lg">{header}</div>
        <div className="flex items-center justify-center">
          <IconButton
            onClick={() => setIsOpen(!isOpen)}
            className={clsx('transition-transform duration-200 text-palette-700', {
              '-rotate-90': !isOpen,
            })}
            icon="chevronDown"
          />
        </div>
      </div>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
            className={clsx('overflow-hidden', bodyClassName)}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
